"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataV2Serializer = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const _1 = require(".");
function getDataV2Serializer() {
    return (0, serializers_1.struct)([
        ['name', (0, serializers_1.string)()],
        ['symbol', (0, serializers_1.string)()],
        ['uri', (0, serializers_1.string)()],
        ['sellerFeeBasisPoints', (0, serializers_1.u16)()],
        ['creators', (0, serializers_1.option)((0, serializers_1.array)((0, _1.getCreatorSerializer)()))],
        ['collection', (0, serializers_1.option)((0, _1.getCollectionSerializer)())],
        ['uses', (0, serializers_1.option)((0, _1.getUsesSerializer)())],
    ], { description: 'DataV2' });
}
exports.getDataV2Serializer = getDataV2Serializer;
//# sourceMappingURL=dataV2.js.map